import React, { useState } from "react";

import moment from "moment";

import WidgetCard from "./card";
import WidgetObligations from "./widgetObligations";
import { useIntl, FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InfoModal from "../../components/uploader/infoModal";
import { FEATURE_TOGGLE_ANALYTICS } from "../../config";
import numeral from "numeral";
import { useSelector } from "react-redux";

const WidgetOperations = () => {

  const analytics = useSelector(state => state.analytics);
  const statistics = useSelector(state => state.statistics);

  const [modal, setModal] = useState({
    content: null,
    visibility: false
  });

  const notAvailableText = useIntl().formatMessage({
    id: "customerPage.registryWidget.notAvailable"
  });

  const obligations =
    analytics &&
    analytics.getObligations &&
    analytics.getObligations.data &&
    analytics.getObligations.data.values &&
    analytics.getObligations.data.values.data &&
    analytics.getObligations.data.values.data.length > 0
      ? analytics.getObligations.data.values
      : null;

  const renderInfo = () => {
    try {
      const renderContent = (
        <WidgetObligations />
      );
      setModal({
        content: renderContent,
        visible: true
      });
    } catch (e) {
      return null;
    }
    return undefined;
  };
  const renderObligations = () => {
    const totalObligations = numeral(obligations.data[0].NumeroAdempimentiAnnoInCorso).format("0,0");
    const totalObligationsLastYear = numeral(obligations.data[0].NumeroAdempimentiAnnoPrecedente).format("0,0");
    const percentage =
      obligations.data[0].PercentualeIncrementoNumeroAdempimenti;

    const positive = Number(percentage) > 0 ? true : false;
    const yearObligations = obligations.dataElaborazione
      ? moment(obligations.dataElaborazione, "YYYYMMDDHHmmss").year() - 1
      : new Date().getFullYear() - 1;

    return (
      <React.Fragment>
        <div
          style={{ display: "flex", alignItems: "center", marginRight: "10px" }}
        >
          <div className="total displayFlex" onClick={() => {
            if (window.aptrinsic) {
              window.aptrinsic("track", "digital-box:SC-OPERATIVITA");
            }
          }}>
            {totalObligations}
            <FontAwesomeIcon
              icon={["far", "eye"]}
              className="infoIcon"
              onClick={renderInfo}
            />
          </div>

          <div
            className={
              positive
                ? "iconStyleUpDown obligationsIcon"
                : "iconStyleUpDown obligationsIcon negative"
            }
          >
            <div style={{ marginRight: "5px" }}>
              <FontAwesomeIcon
                icon={["far", positive ? "long-arrow-up" : "long-arrow-down"]}
              />
            </div>

            {percentage + "%"}
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div className="obligations" style={{ flex: "1 0 auto" }}>
            <FormattedMessage id="customerPage.registryWidget.obligations" />
          </div>

          <div className="yearRevenues">{yearObligations}</div>
          <div className="totalCredit revenues">{totalObligationsLastYear}</div>
        </div>
      </React.Fragment>
    );
  };

  const renderDocs = () => {
    return <div></div>;
  };

  const returnData = data => {
    return data != null
      ? moment(data).format("DD MMM YYYY")
      : notAvailableText;
  };

  const renderStats = () => {
    let lastBankingMovement,
      lastPurchaseInvoice,
      lastSalesInvoice,
      lastSumDue = notAvailableText;

    if (statistics && statistics.dates != null) {
      lastBankingMovement = returnData(statistics.dates.lastBankingMovement);
      lastPurchaseInvoice = returnData(statistics.dates.lastPurchaseInvoice);
      lastSalesInvoice = returnData(statistics.dates.lastSalesInvoice);
      lastSumDue = returnData(statistics.dates.lastSumDue);
    }
    return (
      <div className="statsContainer" id="anagraficaStats">
        <div className="statsText">
          <FormattedMessage id="customerPage.registryWidget.lastBankTransaction" />

          <span className="statsText bold">{lastBankingMovement}</span>
        </div>
        <div className="statsText">
          <FormattedMessage id="customerPage.registryWidget.lastPurchaseInvoice" />

          <span className="statsText bold">{lastPurchaseInvoice}</span>
        </div>
        <div className="statsText">
          <FormattedMessage id="customerPage.registryWidget.lastSalesInvoice" />

          <span className="statsText bold">{lastSalesInvoice}</span>
        </div>
        <div className="statsText">
          <FormattedMessage id="customerPage.registryWidget.lastSumDue" />

          <span className="statsText bold">{lastSumDue}</span>
        </div>
      </div>
    );
  };

  return (
    <WidgetCard
      type={"backgroundOperativita"}
      contentType={"contentType"}
      footer={null}
      titleWidget={
        <div>
          <FormattedMessage id="customerPage.registryWidget.operation" />
        </div>
      }
    >
      <div style={{ flex: " 0 0 auto" }}>
        {FEATURE_TOGGLE_ANALYTICS === "true" &&
          obligations &&
          renderObligations()}
      </div>
      <div
        style={{ flex: " 0 0 auto" }}
        className="break-divider-horizontal"
      ></div>
      <div style={{ flex: " 1 0 auto" }}>{renderDocs()}</div>
      <div style={{ flex: " 0 0 auto" }}>{renderStats()}</div>
      <InfoModal
        content={modal.content}
        colorScheme={"default"}
        isVisible={modal.visible}
        title={<FormattedMessage id="obligations.title" />}
        type="primary"
        contentClass="noPadding"
        onClose={() =>
          setModal({
            content: null,
            visible: false
          })
        }
      />
    </WidgetCard>
  );
};

export default WidgetOperations;
